import { css } from 'styled-components';
import { colors } from '../../colors';

export const Themeless = {
  wrapper: css``,
  box: css``,
  input: css`
    display: none;
  `,
  label: css``,
  text: css``,
  textContainer: css``,
  selected: css``,
};

export const CheckBoxStacks = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;

    .Optioner-checkbox-group {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
    }
  `,
  box: css`
    position: relative;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;

    padding: 14px 48px 14px 20px;
    margin-bottom: 10px;
    min-width: 96px;
    height: auto;
    background-color: ${({ theme }) => theme.colors.shadeLight};
    border-radius: 10px;

    color: ${colors.shadeDark};
    font-size: 18px;
    text-align: left;
    line-height: normal;

    transition: all 0.5s ease-out;
    user-select: none;

    cursor: pointer;

    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: auto;
      right: 13px;

      width: 24px;
      height: 24px;

      border-radius: 4px;
      border: 2px solid ${({ theme }) => theme.colors.shadeMedium};
      box-sizing: border-box;
      transform: translateY(-50%);
    }
  `,
  input: css`
    display: none;
  `,
  label: css`
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 3.7px;
    margin-bottom: 10px;
`,
  selected: css`
    background-color: #DCF7FE;
    ::before {
      content: '';
      background-color: ${colors.newKinedu};
      border-color: ${colors.newKinedu};
      border-color: transparent;
    }

  ::after {
    content: '✔';
    display: block;
    position: absolute;
    top: 50%;
    left: auto;
    right: 8px;
    bottom: 27px;
    display: flex;
    align-self: flex-start;

    width: 24px;
    height: 24px;
    color: white;
    font-size: 13px;
    font-size: 18px;
    text-align: center;
    transform: translateY(-50%);
  }
  `,
  textContainer: css`
    display: inline-block;
    margin: 0;

    color: ${({ theme }) => theme.colors.shadeDark};
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    line-height: 19px;
  `,
};

export const SliderBar = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    margin: 15px 0 0 0;

    .Optioner-box-container {
      width: 100%;
    }

    .Optioner-checkbox-group {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      width: 100%;
    }
  `,
  content: css`
    width: 100%;
  `,
  box: css`
    position: relative;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 0;
    width: 100%;
    min-width: 96px;
    height: 40px;
    background-color: transparent;

    color: ${colors.shadeMediumDark};
    font-size: 14px;
    font-weight: bold;

    text-align: center;

    transition: all 0.5s ease-out;
    user-select: none;

    cursor: pointer;

    &:first-child::after {
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }


    &:last-child::after {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      background-color: ${colors.shadeMediumLight};
      width: 100%;
      height: 4px;
      transition: all 0.5s ease;
    }
  `,
  label: css`
    color: ${colors.shadeMediumDark};
    text-transform: uppercase;

    font-size: 20px;
    font-weight: bold;
    letter-spacing: 5px;

    display: block;
    margin: 20px 0 10px;
  `,
  input: css`
    display: none;
  `,
  selected: css`
    color: ${colors.kinedu};
    &::after {
      background-color: ${colors.kinedu};
    }
  `,
};

const Pills = {
  wrapper: css``,
  checkboxGroup: css`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0px 0 10px;

    .Optioner-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      width: 100%;
    }
  `,
  box: css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    // width: auto;
    min-width: 140px;
    height: 40px;
    margin: 10px 0px;

    padding: 0px 30px;
    background-color: #ACC2D3;
    border-radius: 25px;

    color: white;
    font-size: 18px;
    text-align: center;
    font-weight: bold;

    transition: all 0.5s ease-out;
    cursor: pointer;
  `,
  input: css`
    display: none;
  `,
  label: css`
    position: relative;
    color: #4A4A4A;
    font-size: 16px;
    font-weight: bold;
    text-transform: capitalize;
    letter-spacing: 0;
  `,
  text: css``,
  textContainer: css``,
  selected: css`
    background-color: #0086D8;
    color: white;
  `,
};

interface IThemes {
  [key: string]: any;
}

const OptionerThemes: IThemes = {
  Themeless,
  CheckBoxStacks,
  SliderBar,
  Pills,
};

export default OptionerThemes;
